import ConfigureCCR from "../pages/Configure/ConfigureCCR"
import ConfigureCustom from "../pages/Configure/ConfigureCustom"
import ConfigureStandard from "../pages/Configure/ConfigureStandard"
import CookiesPolicy from "../pages/CookiesPolicy"
import Home from "../pages/Home"
import PrivacyPolicy from "../pages/PrivacyPolicy"
import Summary from "../pages/Summary"
import TermsOfUse from "../pages/TermsOfUse"

const routes = [
  {
    id: "home",
    path: "homelift/",
    index: false,
    component: <Home />,
    layout: "general",
  },
  {
    id: "configure",
    path: "homelift/:CCAB_MODELO/:CCAB_EMBARQUE/configure/:CCAB_AMBIENTE",
    index: false,
    component: <ConfigureStandard />,
    layout: "configurator",
  },
  {
    id: "custom",
    path: "homelift/custom/:SCHEMA/:CCO",
    index: false,
    component: <ConfigureCustom />,
    layout: "configurator",
  },
  {
    id: "ccr",
    path: "homelift/ccr/:SCHEMA/:CCR",
    index: false,
    component: <ConfigureCCR />,
    layout: "configurator",
  },
  {
    id: "summary",
    path: "homelift/:CCAB_MODELO/:CCAB_EMBARQUE/summary",
    index: false,
    component: <Summary />,
    layout: "general",
  },
  {
    id: "terms-of-use",
    path: "homelift/terms-of-use",
    index: false,
    component: <TermsOfUse />,
    layout: "general",
  },
  {
    id: "privacy-policy",
    path: "homelift/privacy-policy",
    index: false,
    component: <PrivacyPolicy />,
    layout: "general",
  },
  {
    id: "cookies-policy",
    path: "homelift/cookies-policy",
    index: false,
    component: <CookiesPolicy />,
    layout: "general",
  },
]

export default routes
